// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

/**
 *  EshopVariantStockHandler | eshop - detail produktu - komponenta productDetailVariantForm
 *  -  pokud uzivatel vybral N-1 variantnich parametru (kde N je celkovy pocet typu variantnich parametru), zobrazi se mu u zbyvajiciho parametru skladovou dostupnost cilovych variant
 *  - data-show-on-label: zobrazi skladovou dostupnost v labelu prislusneho parametru po najeti mysi nad parametr, funguje pouze pro input radio  (default: true)
 *  - data-show-on-input: zobrazi skladovou dostupnost v ramci prislusneho inputu (default: true)
 */
class EshopVariantStockHandler extends WebComponent {
  constructor(props) {
    super(props);
    this.enableMouseOver = this.enableMouseOver.bind(this);
    this.enableRenderOnInput = this.enableRenderOnInput.bind(this);
    this.enableReplaceImage = this.enableReplaceImage.bind(this);
  }
	didMount() {
    const {
      showOnLabel,
      showOnInput,
      replaceImage,
    } = this.props;

    this.formGroups = this.element.querySelectorAll('.form-group');

    //check for touch devices
    function is_touch_enabled() {
      return ( 'ontouchstart' in window ) ||
        ( navigator.maxTouchPoints > 0 ) ||
        ( navigator.msMaxTouchPoints > 0 );
    }

    // pamatování stavu scrollTop při přechodu mezi stránkami
    this.enableScrollTopHandler();

    // zjisti jestli je neco vybraneho
    this.checkIfSelected();

    // zobrazeni dostupnosti pri mouseoveru
    if (showOnLabel && !is_touch_enabled()) {
      this.enableMouseOver();
    }

    // zobrazeni dostupnosti v ramci prislusneho inputu
    if (showOnInput) {
      this.enableRenderOnInput();
    }

    // pri kliknuti nahradit obrazek v galerii za dodany
    if (replaceImage) {
      this.enableReplaceImage();
    }
	}

	enableScrollTopHandler() {
    this.getScrollTop();
    document.addEventListener('beforeFullPageRedirect', (event) => {
      this.saveScrollTop();
    });

    const links = document.querySelectorAll('a[data-turbolinks-save-scroll=true]');

    Array.from(links).forEach(link => {
      link.addEventListener('click', () => {
        this.saveScrollTop();
      });
    });
  }

  checkIfSelected() {
    const colorDescriptionTrigger = this.element.querySelector('.color-description-trigger');
    if (colorDescriptionTrigger) {
      let isChecked = 0;
      Array.from(this.formGroups).forEach(formGroup => {
        const formControls = formGroup.querySelectorAll('.form-group__control');
        Array.from(formControls).forEach(formControl => {
          if (formControl.checked == true) {
            isChecked++;
          }
        });
      });
      isChecked>0?colorDescriptionTrigger.classList.add('variant-selected'):false;      //console.log(isChecked);
    }
  }

  saveScrollTop() {
    const {
      storageTTL,
    } = this.props;

    if (window.localStorage) {
      const now = new Date();
      const item = {
        value: document.scrollingElement.scrollTop,
        expiry: now.getTime() + storageTTL,
      }
      localStorage.setItem('pageScrollTop', JSON.stringify(item));
    }
  }

  getScrollTop() {
    const {
      storageTTL,
    } = this.props;

    if (window.localStorage) {
      const scrollTopData = localStorage.getItem('pageScrollTop');

      if (scrollTopData) {
        const item = JSON.parse(scrollTopData)
        const now = new Date()

        if (now.getTime() > item.expiry) {
          localStorage.removeItem('pageScrollTop');
        }
        else {
          document.scrollingElement.scrollTop = item.value;
        }
      }
    }
  }

	enableMouseOver() {
    const {
      onStockClass,
      notOnStockClass,
      showPriceCompare,
    } = this.props;

    Array.from(this.formGroups).forEach(formGroup => {

      const formControls = formGroup.querySelectorAll('.form-group__control');

      // na select option neexistuje mouseover eventa, v pripade selectu neni podpora mozna

      Array.from(formControls).forEach(formControl => {
        if (formControl.nodeName == "INPUT") {
          const parentElement = formControl.parentElement;
          const formLabel = parentElement.querySelector('label span');
          const formLabelCaption = formLabel.innerText;
          const formGroupLabel = formGroup.querySelector('.form-group__label');
          const formGroupLabelValue = formGroup.querySelector('.form-group__label-value');
          const formGroupLabelCaption = formGroupLabel.innerHTML;
          const onStock = formControl.getAttribute('data-on-stock');
          const availability = formControl.getAttribute('data-availability');
          const price = formControl.getAttribute('data-price');
          let stockInfo = '';
          let priceInfo = '';
          let formGroupLabelValueCaption;

          if (formGroupLabelValue) {
            formGroupLabelValueCaption = formGroupLabelValue.innerHTML;
          }

          if (onStock == "true") {
            stockInfo = `, <span class="${onStockClass}">${availability}</span>`;
          }
          else if (onStock == "false") {
            stockInfo = `, <span class="${notOnStockClass}">${availability}</span>`;
          }

         if (price && showPriceCompare) {
           priceInfo = `, ${price}`;
         }

          parentElement.addEventListener('mouseover', () => {
            if (formGroupLabelValue) {
              formGroupLabelValue.innerHTML = `${formLabelCaption}${stockInfo}${priceInfo}`;
            }
            else {
              formGroupLabel.innerHTML = `${formGroupLabelCaption}<span class="colon">:</span> <span class="form-group__label-value">${formLabelCaption}${stockInfo}${priceInfo}</span>`;
            }
          });
          parentElement.addEventListener('mouseout', () => {
            if (formGroupLabelValue) {
              formGroupLabelValue.innerHTML = formGroupLabelValueCaption;
            }
            else {
              formGroupLabel.innerHTML = formGroupLabelCaption;
            }
          });
        }
      });
    });
  }

  enableRenderOnInput() {
    const {
      onStockClass,
      notOnStockClass,
    } = this.props;

    Array.from(this.formGroups).forEach(formGroup => {

      const formControls = formGroup.querySelectorAll('.form-group__control');
      Array.from(formControls).forEach(formControl => {

        // select
        if (formControl.nodeName == "SELECT") {
          const formControlOptions = formControl.querySelectorAll('option');
          Array.from(formControlOptions).forEach(formControlOption => {
            const onStock = formControlOption.getAttribute('data-on-stock');
            const availability = formControlOption.getAttribute('data-availability');

            if (onStock == 'true') {
              formControlOption.classList.add(onStockClass);
              formControlOption.innerHTML = `${formControlOption.innerHTML}  (${availability})`;
            } else if (onStock == 'false') {
              formControlOption.classList.add(notOnStockClass);
            }
          });
        // input radio
        } else if (formControl.nodeName == "INPUT") {
            const onStock = formControl.getAttribute('data-on-stock');

            if (onStock == 'true') {
              formControl.classList.add(onStockClass);
            } else if (onStock == 'false') {
              formControl.classList.add(notOnStockClass);
            }
        }
      });

    });
  }

  enableReplaceImage() {
    const {
      galleryImageSelector,
      galleryImageLinkSelectorAll,
      galleryImageThumbSelector,
      galleryImageThumbLinkSelector,
      galleryImageThumbLinkSelectorAll,
    } = this.props;

    Array.from(this.formGroups).forEach(formGroup => {
      const formControls = formGroup.querySelectorAll('.form-group__control');

      Array.from(formControls).forEach(formControl => {
        formControl.addEventListener('click', (event) => {
          const imageSource = formControl.getAttribute('data-replace-image-source');
          const imageSourceThumb = formControl.getAttribute('data-replace-image-source-thumb');
          const imageSourceFull = formControl.getAttribute('data-replace-image-source-full');

          this.replaceImage(imageSource,galleryImageSelector,'src');
          this.replaceImage(imageSourceFull,galleryImageSelector,'data-magnify-src');
          this.replaceImage(imageSourceThumb,galleryImageThumbSelector,'src');
          this.replaceImage(imageSource,galleryImageThumbLinkSelector,'href');
          this.replaceImage(imageSourceFull,galleryImageThumbLinkSelector,'data-zoom');

          // set for PU popup gallery
          this.replaceImage(imageSourceThumb,galleryImageLinkSelectorAll,'data-replace-image-source-thumb');
          this.replaceImage(imageSourceThumb,galleryImageThumbLinkSelectorAll,'data-replace-image-source-thumb');
          this.replaceImage(imageSourceFull,galleryImageLinkSelectorAll,'data-replace-image-source-full');
          this.replaceImage(imageSourceFull,galleryImageThumbLinkSelectorAll,'data-replace-image-source-full');
        });
      });
    });
  }

  replaceImage(data, targetSelector, attribute) {
    const targets = document.querySelectorAll(targetSelector);

    if (data && targets.length > 0 && attribute) {
      targets.forEach((target) => {
        target.setAttribute(attribute, data);
      });
    }
  }
}


EshopVariantStockHandler.defaultProps = {
  onStockClass: 'stock-info--available',
  notOnStockClass: 'stock-info--unavailable',
  galleryImageSelector: '.eshop-gallery__item:first-child .eshop-gallery__img',
  galleryImageLinkSelectorAll: '.eshop-gallery__item .eshop-gallery__link',
  galleryImageThumbSelector: '.eshop-gallery__thumblist-item:first-child .eshop-gallery__thumblist-img',
  galleryImageThumbLinkSelector: '.eshop-gallery__thumblist-item:first-child .eshop-gallery__thumblist-link',
  galleryImageThumbLinkSelectorAll: '.eshop-gallery__thumblist-item .eshop-gallery__thumblist-link',
  storageTTL: 5000,
}


export default EshopVariantStockHandler;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/eshop/EshopVariantStockHandler.js